import React from "react"

import { ImageRatio, ImageWrapper, StyledImage } from "../Styled/Image"
import { withShopifyImage } from "./withShopifyImage"

export const ShopifyImage = withShopifyImage(({ alt, cover, onClick, ratio, src, fullWidth, hoverSrc, imageUrl, imageSrcSets, maxWidth }) => {
  return ratio ? (
    <ImageWrapper fullWidth={fullWidth} onClick={onClick} className={hoverSrc ? "group" : ""}>
      <ImageRatio ratio={ratio} />
      <StyledImage
        alt={alt}
        cover
        src={maxWidth ? imageUrl(src, maxWidth) : imageUrl(src, 1)}
        srcSet={!maxWidth ? imageSrcSets(src) : undefined}
        draggable={false}
      />
      {hoverSrc && (
        <StyledImage
          alt={alt}
          cover
          hover
          src={maxWidth ? imageUrl(hoverSrc, maxWidth) : imageUrl(src, 1)}
          srcSet={!maxWidth ? imageSrcSets(hoverSrc) : undefined}
          draggable={false}
        />
      )}
    </ImageWrapper>
  ) : (
    <StyledImage alt={alt} cover={cover} onClick={onClick} src={imageUrl(src, 1)} srcSet={imageSrcSets(src)} />
  )
})
